import React from 'react';
import '../styles/direct-label.css';

const DirectLabel = (props) => {
  return (
    <div className={props.type === 'aaf_content_is_startover' ? "direct-label-container-startover" : "direct-label-container-tv"}>
      {props.label}
    </div>
  );
};

export default DirectLabel;



// WEBPACK FOOTER //
// ./src/playerDomain/components/common/DirectLabel.js